import { Client } from "@xmpp/client"
import { getAllItemsBatched } from "./PubSub"
import { wizardJid } from "@/jidUtils"
import XmppPubSubApi from "../xmppPubSubApi"
import { GpsConfig } from "@/reducers/gpsConfigSlice"
import GpsConfigParser from "@/lib/gpsConfigParser"

export const GPS_CONFIG_NODE = "gps_config"

export const retrieveAllGpsConfig = async (
  xmpp: Client,
): Promise<Array<GpsConfig>> => {
  const items = await getAllItemsBatched({
    xmpp,
    jid: wizardJid(xmpp.jid!),
    node: GPS_CONFIG_NODE,
    timeout: 4000,
  })

  return items.map((item) => {
    return GpsConfigParser.parseItem(item)
  })
}

export const subscribeToGpsConfig = async (client: Client) => {
  try {
    await XmppPubSubApi.subscribe(
      window.XMPP!,
      wizardJid(client.jid!),
      GPS_CONFIG_NODE,
    )
  } catch (error: any) {
    if (error.condition !== "item-not-found") {
      console.warn(`Error subscribing to ${GPS_CONFIG_NODE}`, error)
    }
  }
}
